import { Modal, ModalBody, ModalFooter, ModalHeader, Progress } from "reactstrap";

interface ISyncModalProps {
  showModal: boolean;
  maxItems: number;
  currentItems: number;
  syncCanceled: boolean;
  toggleModal: () => void;
  onClickCancel: () => void;
}

const SyncModal = (props: ISyncModalProps) => {
  return (
    <div>
      <Modal isOpen={props.showModal} toggle={props.toggleModal}>
          <ModalHeader toggle={props.toggleModal}>Sincronizacion de John Deere</ModalHeader>
          <ModalBody>
            { props.maxItems == 0 || props.maxItems === undefined ? (
              <p>Obteniendo datos...</p>
            ) : (
              <>
                <p>Sincronizando elementos</p>
                <Progress animated color="info" max={props.maxItems} value={props.currentItems}>
                  {Math.floor((props.currentItems / props.maxItems) * 100)}%
                </Progress>
              </>
            )}
            { props.syncCanceled && (
              <p>Cancelando la sincronización...</p>
            )}
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-danger btn-rounded btn-block"
              type="button"
              onClick={props.onClickCancel}
            >
              Cancelar
            </button>
          </ModalFooter>
        </Modal>
    </div>
  )
}

export default SyncModal;